import React, {
    useState
} from 'react';

import {
    useDispatch,
    useSelector
} from 'react-redux';

import {
    Link
} from 'react-router-dom';


import SelectorUbicacion
    from '../Metodos/Compartidos/Ubicacion/SelectorUbicacion';

import TerminosCondicionesModal
    from './TerminosCondicionesModal';


import {
    tipoProfesionalData,
    nivelEstudiosData,
    ocupacionProfesionalData,
    generoData
} from '../../Hooks/dropdowns';


import {
    crearNuevoUsuarioAction
} from '../../actions/nuevoUsuarioActions';


import {

    PaginaNuevaCuenta,

    HeaderNuevaCuenta,
    LogoLinkNuevaCuenta,
    LogoNuevaCuenta,
    LinkLoginNuevaCuenta,

    ContenedorNuevaCuenta,

    PanelNuevaCuenta,
    EtiquetaPanel,
    TituloPanel,
    TextoPanel,
    ListaPanel,
    ItemPanel,
    IlustracionNuevaCuenta,

    TarjetaNuevaCuenta,

    EncabezadoFormulario,
    TituloFormulario,
    TextoFormulario,

    FormularioNuevaCuenta,

    SeccionNuevaCuenta,
    EncabezadoSeccion,
    TituloSeccion,
    TextoSeccion,

    GridFormulario,
    CampoFormulario,

    LabelFormulario,
    Obligatorio,

    InputFormulario,
    SelectFormulario,

    CampoPassword,
    BotonVerPassword,

    TextoError,

    BloqueUbicacion,

    RequisitosPassword,
    RequisitoPassword,

    FilaTerminos,
    CheckboxTerminos,
    TextoTerminos,

    MensajeBackend,

    AccionesFormulario,
    BotonCrearCuenta,

    TextoLoginMobile

} from '../Css/StyledNuevaCuenta';


/*
========================================
FORMULARIO INICIAL
========================================
*/

const FORMULARIO_INICIAL = {

    /*
    Datos personales
    */

    nombre: '',
    apellido: '',
    email: '',
    fechaNacimiento: '',
    genero: '',


    /*
    Datos profesionales
    */

    profesion: '',
    otroProfesion: '',
    nivelEstudio: '',
    ocupacion: '',
    matricula: '',


    /*
    Seguridad
    */

    password: '',
    verificarPassword: ''

};


/*
========================================
VALIDAR EMAIL
========================================
*/

const emailValido = (
    email
) => {

    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        .test(
            email
        );

};


/*
========================================
NUEVA CUENTA
========================================
*/

const NuevaCuenta = () => {

    const dispatch =
        useDispatch();


    /*
    ====================================
    REDUX
    ====================================
    */

    const cargando =
        useSelector(
            state =>
                state.estado.loading
        );


    const errorBackend =
        useSelector(
            state =>
                state.estado.error
        );


    /*
    ====================================
    FORMULARIO
    ====================================
    */

    const [
        formulario,
        setFormulario
    ] = useState(
        FORMULARIO_INICIAL
    );


    const [
        ubicacion,
        setUbicacion
    ] = useState({});


    const [
        errores,
        setErrores
    ] = useState({});


    const [
        aceptoCondiciones,
        setAceptoCondiciones
    ] = useState(false);


    const [
        mostrarPassword,
        setMostrarPassword
    ] = useState(false);


    /*
    ====================================
    CAMBIAR CAMPO
    ====================================
    */

    const cambiarCampo = (
        e
    ) => {

        const {
            name,
            value
        } = e.target;


        setFormulario(
            anterior => ({

                ...anterior,

                [name]:
                    value

            })
        );


        /*
        Al corregir un campo eliminamos
        inmediatamente su mensaje.
        */

        if (
            errores[name]
        ) {

            setErrores(
                anteriores => {

                    const nuevos = {
                        ...anteriores
                    };


                    delete nuevos[
                        name
                    ];


                    return nuevos;

                }
            );

        }

    };


    /*
    ====================================
    CAMBIAR UBICACIÓN
    ====================================
    */

    const cambiarUbicacion = (
        nuevaUbicacion
    ) => {

        setUbicacion(
            nuevaUbicacion
        );


        if (
            errores.ubicacion
        ) {

            setErrores(
                anteriores => {

                    const nuevos = {
                        ...anteriores
                    };


                    delete nuevos.ubicacion;


                    return nuevos;

                }
            );

        }

    };


    /*
    ====================================
    VALIDAR UBICACIÓN
    ====================================

    No tratamos de interpretar acá toda
    la estructura internacional.

    Verificamos que haya un país y que
    se haya comenzado a definir su
    división territorial.

    Backend vuelve a validar y normalizar.
    ====================================
    */

    const ubicacionValida = () => {

        if (
            !ubicacion ||
            typeof ubicacion !==
            'object'
        ) {

            return false;

        }


        /*
        ====================================
        PAÍS
        ====================================
        */

        if (
            !ubicacion.pais_codigo
        ) {

            return false;

        }


        /*
        ====================================
        OTRO PAÍS
        ====================================
        */

        if (
            ubicacion.pais_codigo ===
            'OTRO'
        ) {

            return Boolean(

                String(
                    ubicacion.pais ||
                    ''
                ).trim() &&

                String(
                    ubicacion.provincia ||
                    ''
                ).trim() &&

                String(
                    ubicacion.localidad ||
                    ''
                ).trim()

            );

        }


        /*
        ====================================
        PAÍS CONFIGURADO
        ====================================
        */

        const niveles =
            Object.values(
                ubicacion.niveles ||
                {}
            )
                .filter(Boolean)
                .sort(
                    (a, b) =>
                        Number(
                            a?.nivel || 0
                        ) -
                        Number(
                            b?.nivel || 0
                        )
                );


        if (
            niveles.length ===
            0
        ) {

            return false;

        }


        /*
        ====================================
        LOCALIDAD DEL CATÁLOGO
        ====================================

        La ubicación está completa si alguno
        de los niveles seleccionados fue
        identificado como localidad.
        */

        const tieneLocalidadSeleccionada =
            niveles.some(
                nivel =>
                    nivel?.es_localidad ===
                    true
            );


        if (
            tieneLocalidadSeleccionada
        ) {

            return true;

        }


        /*
        ====================================
        LOCALIDAD MANUAL
        ====================================

        Caso:

        "No encuentro mi localidad"

        En ese caso no existe nivel geográfico
        marcado como localidad y exigimos que
        el usuario escriba localidad_manual.
        */

        const localidadManual =
            String(
                ubicacion.localidad_manual ||
                ''
            ).trim();


        return Boolean(
            localidadManual
        );

    };


    /*
    ====================================
    VALIDAR FORMULARIO
    ====================================
    */

    const validarFormulario = () => {

        const nuevosErrores =
            {};


        /*
        ====================================
        DATOS PERSONALES
        ====================================
        */

        if (
            !formulario
                .nombre
                .trim()
        ) {

            nuevosErrores.nombre =
                'Completá tu nombre';

        }


        if (
            !formulario
                .apellido
                .trim()
        ) {

            nuevosErrores.apellido =
                'Completá tu apellido';

        }


        if (
            !formulario
                .email
                .trim()
        ) {

            nuevosErrores.email =
                'Completá tu email';

        } else if (
            !emailValido(
                formulario
                    .email
                    .trim()
            )
        ) {

            nuevosErrores.email =
                'Ingresá un email válido';

        }


        if (
            !formulario.fechaNacimiento
        ) {

            nuevosErrores.fechaNacimiento =
                'Completá tu fecha de nacimiento';

        }


        if (
            !formulario.genero
        ) {

            nuevosErrores.genero =
                'Seleccioná una opción';

        }


        /*
        ====================================
        DATOS PROFESIONALES
        ====================================
        */

        if (
            !formulario.profesion
        ) {

            nuevosErrores.profesion =
                'Seleccioná tu profesión';

        }


        if (
            formulario.profesion ===
            '99' &&

            !formulario
                .otroProfesion
                .trim()
        ) {

            nuevosErrores.otroProfesion =
                'Indicá tu profesión';

        }


        if (
            !formulario.nivelEstudio
        ) {

            nuevosErrores.nivelEstudio =
                'Seleccioná tu nivel de estudio';

        }


        if (
            !formulario.ocupacion
        ) {

            nuevosErrores.ocupacion =
                'Seleccioná tu ocupación';

        }


        if (
            !formulario
                .matricula
                .trim()
        ) {

            nuevosErrores.matricula =
                'Completá tu matrícula';

        }


        /*
        ====================================
        UBICACIÓN
        ====================================
        */

        if (
            !ubicacionValida()
        ) {

            nuevosErrores.ubicacion =
                'Completá tu ubicación';

        }


        /*
        ====================================
        CONTRASEÑA
        ====================================
        */

        if (
            !formulario.password
        ) {

            nuevosErrores.password =
                'Completá una contraseña';

        } else {

            if (
                formulario
                    .password
                    .length <
                8 ||
                formulario
                    .password
                    .length >
                15
            ) {

                nuevosErrores.password =
                    'La contraseña debe tener entre 8 y 15 caracteres';

            } else if (
                !/[a-z]/
                    .test(
                        formulario.password
                    )
            ) {

                nuevosErrores.password =
                    'Debe incluir al menos una minúscula';

            } else if (
                !/[A-Z]/
                    .test(
                        formulario.password
                    )
            ) {

                nuevosErrores.password =
                    'Debe incluir al menos una mayúscula';

            } else if (
                !/[0-9]/
                    .test(
                        formulario.password
                    )
            ) {

                nuevosErrores.password =
                    'Debe incluir al menos un número';

            }

        }


        if (
            !formulario
                .verificarPassword
        ) {

            nuevosErrores.verificarPassword =
                'Repetí tu contraseña';

        } else if (
            formulario.password !==
            formulario.verificarPassword
        ) {

            nuevosErrores.verificarPassword =
                'Las contraseñas no coinciden';

        }


        /*
        ====================================
        TÉRMINOS
        ====================================
        */

        if (
            !aceptoCondiciones
        ) {

            nuevosErrores.condiciones =
                'Debés aceptar los términos y condiciones';

        }


        setErrores(
            nuevosErrores
        );


        return (
            Object.keys(
                nuevosErrores
            ).length ===
            0
        );

    };


    /*
    ====================================
    SUBMIT
    ====================================
    */

    const submitNuevoUsuario = (
        e
    ) => {

        e.preventDefault();


        if (
            !validarFormulario()
        ) {

            /*
            Lleva al usuario al primer
            campo con error.
            */

            setTimeout(
                () => {

                    const primerError =
                        document
                            .querySelector(
                                '[data-error="true"]'
                            );


                    primerError
                        ?.scrollIntoView({

                            behavior:
                                'smooth',

                            block:
                                'center'

                        });

                },
                0
            );


            return;

        }


        /*
        ====================================
        CREAR PROFESIONAL
        ====================================

        IMPORTANTE:

        Ya no enviamos:

        pais
        provincia
        departamento
        localidad

        El frontend envía exclusivamente
        la nueva ubicación.

        Backend genera además los legacy
        mientras dure la transición.
        ====================================
        */

        dispatch(
            crearNuevoUsuarioAction({

                nombre:
                    formulario
                        .nombre
                        .trim(),

                apellido:
                    formulario
                        .apellido
                        .trim(),

                email:
                    formulario
                        .email
                        .trim()
                        .toLowerCase(),

                password:
                    formulario.password,

                profesion:
                    formulario.profesion,

                otroProfesion:
                    formulario.profesion ===
                    '99'
                        ?
                        formulario
                            .otroProfesion
                            .trim()
                        :
                        '',


                /*
                Nueva ubicación
                */

                ubicacion,


                tipoUsuario:
                    'Profesional',

                genero:
                    formulario.genero,

                fechaNacimiento:
                    formulario.fechaNacimiento,

                nivelEstudio:
                    formulario.nivelEstudio,

                ocupacion:
                    formulario.ocupacion,

                matricula:
                    formulario
                        .matricula
                        .trim()

            })
        );

    };


    /*
    ====================================
    ERROR BACKEND
    ====================================
    */

    const mensajeErrorBackend =

        typeof errorBackend ===
        'string'

            ?
            errorBackend

            :
            errorBackend?.msg ||
            '';


    /*
    ====================================
    ESTADO REQUISITOS PASSWORD
    ====================================
    */

    const passwordTieneLongitud =
        formulario.password.length >= 8 &&
        formulario.password.length <= 15;


    const passwordTieneMinuscula =
        /[a-z]/
            .test(
                formulario.password
            );


    const passwordTieneMayuscula =
        /[A-Z]/
            .test(
                formulario.password
            );


    const passwordTieneNumero =
        /[0-9]/
            .test(
                formulario.password
            );


    return (

        <PaginaNuevaCuenta>


            {/* =========================
                HEADER
            ========================== */}

            <HeaderNuevaCuenta>

                <LogoLinkNuevaCuenta
                    as={Link}
                    to="/"
                >

                    <LogoNuevaCuenta
                        src="/img/metodoYogenLogo_recortado.png"
                        alt="Método YÖGEN"
                    />

                </LogoLinkNuevaCuenta>


                <LinkLoginNuevaCuenta
                    as={Link}
                    to="/login"
                >

                    Iniciar sesión

                </LinkLoginNuevaCuenta>

            </HeaderNuevaCuenta>


            {/* =========================
                CONTENIDO
            ========================== */}

            <ContenedorNuevaCuenta>


                {/* =====================
                    PANEL IZQUIERDO
                ====================== */}

                <PanelNuevaCuenta>

                    <EtiquetaPanel>
                        MÉTODO YÖGEN
                    </EtiquetaPanel>


                    <TituloPanel>
                        Creá tu espacio profesional
                    </TituloPanel>


                    <TextoPanel>

                        Organizá pacientes,
                        intervenciones y herramientas
                        de trabajo desde una misma
                        plataforma.

                    </TextoPanel>


                    <ListaPanel>

                        <ItemPanel>
                            ✓ Gestión de pacientes
                        </ItemPanel>

                        <ItemPanel>
                            ✓ Calendario e historia clínica
                        </ItemPanel>

                        <ItemPanel>
                            ✓ Actividades y materiales
                        </ItemPanel>

                    </ListaPanel>


                    <IlustracionNuevaCuenta
                        src="/img/IlustracionNuevaCuenta.png"
                        alt=""
                    />

                </PanelNuevaCuenta>


                {/* =====================
                    FORMULARIO
                ====================== */}

                <TarjetaNuevaCuenta>


                    <EncabezadoFormulario>

                        <TituloFormulario>
                            Crear cuenta
                        </TituloFormulario>


                        <TextoFormulario>

                            Completá tus datos para
                            registrarte como profesional.

                        </TextoFormulario>

                    </EncabezadoFormulario>


                    {
                        mensajeErrorBackend && (

                            <MensajeBackend
                                $error
                            >

                                {
                                    mensajeErrorBackend
                                }

                            </MensajeBackend>

                        )
                    }


                    <FormularioNuevaCuenta
                        onSubmit={
                            submitNuevoUsuario
                        }
                        noValidate
                    >


                        {/* =====================
                            DATOS PERSONALES
                        ====================== */}

                        <SeccionNuevaCuenta>

                            <EncabezadoSeccion>

                                <TituloSeccion>
                                    Datos personales
                                </TituloSeccion>

                                <TextoSeccion>

                                    Los campos marcados
                                    con * son obligatorios.

                                </TextoSeccion>

                            </EncabezadoSeccion>


                            <GridFormulario>


                                <CampoFormulario
                                    data-error={
                                        errores.nombre
                                            ?
                                            'true'
                                            :
                                            'false'
                                    }
                                >

                                    <LabelFormulario
                                        htmlFor="nombre"
                                    >

                                        Nombre
                                        <Obligatorio>
                                            *
                                        </Obligatorio>

                                    </LabelFormulario>


                                    <InputFormulario

                                        id="nombre"
                                        name="nombre"

                                        type="text"

                                        autoComplete="given-name"

                                        value={
                                            formulario.nombre
                                        }

                                        disabled={
                                            cargando
                                        }

                                        onChange={
                                            cambiarCampo
                                        }

                                    />


                                    {
                                        errores.nombre && (

                                            <TextoError>
                                                {errores.nombre}
                                            </TextoError>

                                        )
                                    }

                                </CampoFormulario>


                                <CampoFormulario
                                    data-error={
                                        errores.apellido
                                            ?
                                            'true'
                                            :
                                            'false'
                                    }
                                >

                                    <LabelFormulario
                                        htmlFor="apellido"
                                    >

                                        Apellido
                                        <Obligatorio>
                                            *
                                        </Obligatorio>

                                    </LabelFormulario>


                                    <InputFormulario

                                        id="apellido"
                                        name="apellido"

                                        type="text"

                                        autoComplete="family-name"

                                        value={
                                            formulario.apellido
                                        }

                                        disabled={
                                            cargando
                                        }

                                        onChange={
                                            cambiarCampo
                                        }

                                    />


                                    {
                                        errores.apellido && (

                                            <TextoError>
                                                {errores.apellido}
                                            </TextoError>

                                        )
                                    }

                                </CampoFormulario>


                                <CampoFormulario
                                    data-error={
                                        errores.email
                                            ?
                                            'true'
                                            :
                                            'false'
                                    }
                                    $completo
                                >

                                    <LabelFormulario
                                        htmlFor="email"
                                    >

                                        Email
                                        <Obligatorio>
                                            *
                                        </Obligatorio>

                                    </LabelFormulario>


                                    <InputFormulario

                                        id="email"
                                        name="email"

                                        type="email"

                                        autoComplete="email"

                                        placeholder="nombre@email.com"

                                        value={
                                            formulario.email
                                        }

                                        disabled={
                                            cargando
                                        }

                                        onChange={
                                            cambiarCampo
                                        }

                                    />


                                    {
                                        errores.email && (

                                            <TextoError>
                                                {errores.email}
                                            </TextoError>

                                        )
                                    }

                                </CampoFormulario>


                                <CampoFormulario
                                    data-error={
                                        errores.fechaNacimiento
                                            ?
                                            'true'
                                            :
                                            'false'
                                    }
                                >

                                    <LabelFormulario
                                        htmlFor="fechaNacimiento"
                                    >

                                        Fecha de nacimiento
                                        <Obligatorio>
                                            *
                                        </Obligatorio>

                                    </LabelFormulario>


                                    <InputFormulario

                                        id="fechaNacimiento"
                                        name="fechaNacimiento"

                                        type="date"

                                        value={
                                            formulario
                                                .fechaNacimiento
                                        }

                                        disabled={
                                            cargando
                                        }

                                        onChange={
                                            cambiarCampo
                                        }

                                    />


                                    {
                                        errores.fechaNacimiento && (

                                            <TextoError>
                                                {
                                                    errores
                                                        .fechaNacimiento
                                                }
                                            </TextoError>

                                        )
                                    }

                                </CampoFormulario>


                                <CampoFormulario
                                    data-error={
                                        errores.genero
                                            ?
                                            'true'
                                            :
                                            'false'
                                    }
                                >

                                    <LabelFormulario
                                        htmlFor="genero"
                                    >

                                        Género
                                        <Obligatorio>
                                            *
                                        </Obligatorio>

                                    </LabelFormulario>


                                    <SelectFormulario
                                        id="genero"
                                        name="genero"
                                        value={formulario.genero}
                                        disabled={cargando}
                                        onChange={cambiarCampo}
                                    >

                                        <option value="">
                                            Seleccionar
                                        </option>


                                        {
                                            generoData.map(
                                                opcion => (

                                                    <option
                                                        key={opcion.id}
                                                        value={opcion.id}
                                                    >
                                                        {opcion.parametro}
                                                    </option>

                                                )
                                            )
                                        }

                                    </SelectFormulario>


                                    {
                                        errores.genero && (

                                            <TextoError>
                                                {errores.genero}
                                            </TextoError>

                                        )
                                    }

                                </CampoFormulario>


                            </GridFormulario>

                        </SeccionNuevaCuenta>


                        {/* =====================
                            DATOS PROFESIONALES
                        ====================== */}

                        <SeccionNuevaCuenta>

                            <EncabezadoSeccion>

                                <TituloSeccion>
                                    Datos profesionales
                                </TituloSeccion>

                            </EncabezadoSeccion>


                            <GridFormulario>


                                <CampoFormulario
                                    data-error={
                                        errores.profesion
                                            ?
                                            'true'
                                            :
                                            'false'
                                    }
                                >

                                    <LabelFormulario
                                        htmlFor="profesion"
                                    >

                                        Profesión
                                        <Obligatorio>
                                            *
                                        </Obligatorio>

                                    </LabelFormulario>


                                    <SelectFormulario

                                        id="profesion"
                                        name="profesion"

                                        value={
                                            formulario.profesion
                                        }

                                        disabled={
                                            cargando
                                        }

                                        onChange={
                                            cambiarCampo
                                        }

                                    >

                                        <option value="">
                                            Seleccionar profesión
                                        </option>


                                        {
                                            tipoProfesionalData
                                                .map(
                                                    opcion => (

                                                        <option
                                                            key={
                                                                opcion.id
                                                            }
                                                            value={
                                                                opcion.id
                                                            }
                                                        >

                                                            {
                                                                opcion.parametro
                                                            }

                                                        </option>

                                                    )
                                                )
                                        }

                                    </SelectFormulario>


                                    {
                                        errores.profesion && (

                                            <TextoError>
                                                {errores.profesion}
                                            </TextoError>

                                        )
                                    }

                                </CampoFormulario>


                                {
                                    formulario.profesion ===
                                    '99' && (

                                        <CampoFormulario
                                            data-error={
                                                errores.otroProfesion
                                                    ?
                                                    'true'
                                                    :
                                                    'false'
                                            }
                                        >

                                            <LabelFormulario
                                                htmlFor="otroProfesion"
                                            >

                                                Otra profesión
                                                <Obligatorio>
                                                    *
                                                </Obligatorio>

                                            </LabelFormulario>


                                            <InputFormulario

                                                id="otroProfesion"
                                                name="otroProfesion"

                                                type="text"

                                                value={
                                                    formulario
                                                        .otroProfesion
                                                }

                                                disabled={
                                                    cargando
                                                }

                                                onChange={
                                                    cambiarCampo
                                                }

                                            />


                                            {
                                                errores.otroProfesion && (

                                                    <TextoError>
                                                        {
                                                            errores
                                                                .otroProfesion
                                                        }
                                                    </TextoError>

                                                )
                                            }

                                        </CampoFormulario>

                                    )
                                }


                                <CampoFormulario
                                    data-error={
                                        errores.nivelEstudio
                                            ?
                                            'true'
                                            :
                                            'false'
                                    }
                                >

                                    <LabelFormulario
                                        htmlFor="nivelEstudio"
                                    >

                                        Nivel de estudio
                                        <Obligatorio>
                                            *
                                        </Obligatorio>

                                    </LabelFormulario>


                                    <SelectFormulario
                                        id="nivelEstudio"
                                        name="nivelEstudio"
                                        value={formulario.nivelEstudio}
                                        disabled={cargando}
                                        onChange={cambiarCampo}
                                    >

                                        <option value="">
                                            Seleccionar
                                        </option>


                                        {
                                            nivelEstudiosData.map(
                                                opcion => (

                                                    <option
                                                        key={opcion.id}
                                                        value={opcion.id}
                                                    >
                                                        {opcion.parametro}
                                                    </option>

                                                )
                                            )
                                        }

                                    </SelectFormulario>


                                    {
                                        errores.nivelEstudio && (

                                            <TextoError>
                                                {
                                                    errores
                                                        .nivelEstudio
                                                }
                                            </TextoError>

                                        )
                                    }

                                </CampoFormulario>


                                <CampoFormulario
                                    data-error={
                                        errores.ocupacion
                                            ?
                                            'true'
                                            :
                                            'false'
                                    }
                                >

                                    <LabelFormulario
                                        htmlFor="ocupacion"
                                    >

                                        Ocupación
                                        <Obligatorio>
                                            *
                                        </Obligatorio>

                                    </LabelFormulario>


                                    <SelectFormulario
                                        id="ocupacion"
                                        name="ocupacion"
                                        value={formulario.ocupacion}
                                        disabled={cargando}
                                        onChange={cambiarCampo}
                                    >

                                        <option value="">
                                            Seleccionar
                                        </option>


                                        {
                                            ocupacionProfesionalData.map(
                                                opcion => (

                                                    <option
                                                        key={opcion.id}
                                                        value={opcion.id}
                                                    >
                                                        {opcion.parametro}
                                                    </option>

                                                )
                                            )
                                        }

                                    </SelectFormulario>


                                    {
                                        errores.ocupacion && (

                                            <TextoError>
                                                {errores.ocupacion}
                                            </TextoError>

                                        )
                                    }

                                </CampoFormulario>


                                <CampoFormulario
                                    data-error={
                                        errores.matricula
                                            ?
                                            'true'
                                            :
                                            'false'
                                    }
                                    $completo={
                                        formulario.profesion ===
                                        '99'
                                    }
                                >

                                    <LabelFormulario
                                        htmlFor="matricula"
                                    >

                                        Matrícula
                                        <Obligatorio>
                                            *
                                        </Obligatorio>

                                    </LabelFormulario>


                                    <InputFormulario

                                        id="matricula"
                                        name="matricula"

                                        type="text"

                                        placeholder="Ingresá tu matrícula"

                                        value={
                                            formulario.matricula
                                        }

                                        disabled={
                                            cargando
                                        }

                                        onChange={
                                            cambiarCampo
                                        }

                                    />


                                    {
                                        errores.matricula && (

                                            <TextoError>
                                                {errores.matricula}
                                            </TextoError>

                                        )
                                    }

                                </CampoFormulario>


                            </GridFormulario>

                        </SeccionNuevaCuenta>


                        {/* =====================
                            UBICACIÓN
                        ====================== */}

                        <SeccionNuevaCuenta>

                            <EncabezadoSeccion>

                                <TituloSeccion>
                                    Ubicación
                                </TituloSeccion>

                                <TextoSeccion>

                                    Esta información nos
                                    permite organizar tu
                                    perfil por región.

                                </TextoSeccion>

                            </EncabezadoSeccion>


                            <BloqueUbicacion
                                data-error={
                                    errores.ubicacion
                                        ?
                                        'true'
                                        :
                                        'false'
                                }
                            >

                                <SelectorUbicacion

                                    value={
                                        ubicacion
                                    }

                                    onChange={
                                        cambiarUbicacion
                                    }

                                    prefijo="registro-profesional"

                                    titulo="Ubicación profesional"

                                    disabled={
                                        cargando
                                    }

                                />


                                {
                                    errores.ubicacion && (

                                        <TextoError>
                                            {errores.ubicacion}
                                        </TextoError>

                                    )
                                }

                            </BloqueUbicacion>

                        </SeccionNuevaCuenta>


                        {/* =====================
                            SEGURIDAD
                        ====================== */}

                        <SeccionNuevaCuenta>

                            <EncabezadoSeccion>

                                <TituloSeccion>
                                    Seguridad
                                </TituloSeccion>

                                <TextoSeccion>

                                    Creá una contraseña
                                    segura para acceder
                                    a tu cuenta.

                                </TextoSeccion>

                            </EncabezadoSeccion>


                            <GridFormulario>


                                <CampoFormulario
                                    data-error={
                                        errores.password
                                            ?
                                            'true'
                                            :
                                            'false'
                                    }
                                >

                                    <LabelFormulario
                                        htmlFor="password"
                                    >

                                        Contraseña
                                        <Obligatorio>
                                            *
                                        </Obligatorio>

                                    </LabelFormulario>


                                    <CampoPassword>

                                        <InputFormulario

                                            id="password"
                                            name="password"

                                            type={
                                                mostrarPassword
                                                    ?
                                                    'text'
                                                    :
                                                    'password'
                                            }

                                            autoComplete="new-password"

                                            value={
                                                formulario.password
                                            }

                                            disabled={
                                                cargando
                                            }

                                            onChange={
                                                cambiarCampo
                                            }

                                        />


                                        <BotonVerPassword

                                            type="button"

                                            onClick={() =>
                                                setMostrarPassword(
                                                    anterior =>
                                                        !anterior
                                                )
                                            }

                                            aria-label={
                                                mostrarPassword
                                                    ?
                                                    'Ocultar contraseña'
                                                    :
                                                    'Mostrar contraseña'
                                            }

                                        >

                                            {
                                                mostrarPassword
                                                    ?
                                                    'Ocultar'
                                                    :
                                                    'Ver'
                                            }

                                        </BotonVerPassword>

                                    </CampoPassword>


                                    {
                                        errores.password && (

                                            <TextoError>
                                                {errores.password}
                                            </TextoError>

                                        )
                                    }

                                </CampoFormulario>


                                <CampoFormulario
                                    data-error={
                                        errores.verificarPassword
                                            ?
                                            'true'
                                            :
                                            'false'
                                    }
                                >

                                    <LabelFormulario
                                        htmlFor="verificarPassword"
                                    >

                                        Repetir contraseña
                                        <Obligatorio>
                                            *
                                        </Obligatorio>

                                    </LabelFormulario>


                                    <InputFormulario

                                        id="verificarPassword"
                                        name="verificarPassword"

                                        type={
                                            mostrarPassword
                                                ?
                                                'text'
                                                :
                                                'password'
                                        }

                                        autoComplete="new-password"

                                        value={
                                            formulario
                                                .verificarPassword
                                        }

                                        disabled={
                                            cargando
                                        }

                                        onChange={
                                            cambiarCampo
                                        }

                                    />


                                    {
                                        errores.verificarPassword && (

                                            <TextoError>
                                                {
                                                    errores
                                                        .verificarPassword
                                                }
                                            </TextoError>

                                        )
                                    }

                                </CampoFormulario>


                            </GridFormulario>


                            <RequisitosPassword>

                                <RequisitoPassword
                                    $cumplido={
                                        passwordTieneLongitud
                                    }
                                >
                                    8 a 15 caracteres
                                </RequisitoPassword>


                                <RequisitoPassword
                                    $cumplido={
                                        passwordTieneMinuscula &&
                                        passwordTieneMayuscula
                                    }
                                >
                                    Mayúscula y minúscula
                                </RequisitoPassword>


                                <RequisitoPassword
                                    $cumplido={
                                        passwordTieneNumero
                                    }
                                >
                                    Al menos un número
                                </RequisitoPassword>

                            </RequisitosPassword>


                            <FilaTerminos
                                data-error={
                                    errores.condiciones
                                        ?
                                        'true'
                                        :
                                        'false'
                                }
                            >

                                <CheckboxTerminos

                                    type="checkbox"

                                    id="aceptoCondiciones"

                                    checked={
                                        aceptoCondiciones
                                    }

                                    disabled={
                                        cargando
                                    }

                                    onChange={
                                        e => {

                                            setAceptoCondiciones(
                                                e.target.checked
                                            );


                                            if (
                                                errores.condiciones
                                            ) {

                                                setErrores(
                                                    anteriores => {

                                                        const nuevos = {
                                                            ...anteriores
                                                        };


                                                        delete nuevos
                                                            .condiciones;


                                                        return nuevos;

                                                    }
                                                );

                                            }

                                        }
                                    }

                                />


                                <TextoTerminos>

                                    Acepto la{' '}

                                    <TerminosCondicionesModal />

                                </TextoTerminos>

                            </FilaTerminos>


                            {
                                errores.condiciones && (

                                    <TextoError>
                                        {errores.condiciones}
                                    </TextoError>

                                )
                            }

                        </SeccionNuevaCuenta>


                        {/* =====================
                            ACCIONES
                        ====================== */}

                        <AccionesFormulario>

                            <BotonCrearCuenta

                                type="submit"

                                disabled={
                                    cargando
                                }

                            >

                                {
                                    cargando
                                        ?
                                        'Creando cuenta...'
                                        :
                                        'Crear cuenta'
                                }

                            </BotonCrearCuenta>

                        </AccionesFormulario>


                        <TextoLoginMobile>

                            ¿Ya tenés una cuenta?{' '}

                            <Link to="/login">
                                Iniciá sesión
                            </Link>

                        </TextoLoginMobile>


                    </FormularioNuevaCuenta>

                </TarjetaNuevaCuenta>

            </ContenedorNuevaCuenta>

        </PaginaNuevaCuenta>

    );

};


export default NuevaCuenta;